/** Preço da consulta completa, definido no .env do backend (COMPLETE_CONSULTATION_*). */
export type ConsultationPricing = {
  currency: 'BRL'
  completeConsultation: {
    price: number
    priceCents: number
    /** Preço "De" riscado. `null` quando não há desconto configurado. */
    originalPrice: number | null
    originalPriceCents: number | null
    discountPercent: number | null
  }
}

const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:3000/api/v1').replace(/\/$/, '')

/** Rota pública: não exige x-api-key. */
export async function fetchPricing(signal?: AbortSignal): Promise<ConsultationPricing> {
  const response = await fetch(`${apiBaseUrl}/pricing`, { cache: 'no-store', signal })
  const payload = (await response.json().catch(() => null)) as { data?: ConsultationPricing } | null

  if (!response.ok || typeof payload?.data?.completeConsultation?.price !== 'number') {
    throw new Error('Não foi possível carregar o preço da consulta.')
  }

  return payload.data
}

/** id do <script type="application/json"> com o preço gravado na pré-renderização do build. */
export const EMBEDDED_PRICING_ELEMENT_ID = 'pv-pricing'

/**
 * Preço gravado no HTML pela pré-renderização. Evita mostrar "R$ --,--" enquanto o
 * preço atualizado chega do backend (ele continua sendo buscado logo em seguida).
 */
export function readEmbeddedPricing(): ConsultationPricing | null {
  if (typeof document === 'undefined') return null

  try {
    const element = document.getElementById(EMBEDDED_PRICING_ELEMENT_ID)
    const data = element?.textContent ? (JSON.parse(element.textContent) as ConsultationPricing) : null
    return typeof data?.completeConsultation?.price === 'number' ? data : null
  } catch {
    return null
  }
}
